package org.example.project.model

import kotlinx.serialization.Serializable

@Serializable
data class AttackCharges(
    val crossFire: Int = 2,
    val clusterBomb: Int = 1,
    val lineStrike: Int = 1,
    val sonar: Int = 2
) {
    fun chargeFor(type: AttackType): Int =
        when (type) {
            AttackType.TORPEDO -> Int.MAX_VALUE
            AttackType.CROSS_FIRE -> crossFire
            AttackType.CLUSTER_BOMB -> clusterBomb
            AttackType.LINE_STRIKE -> lineStrike
            AttackType.SONAR -> sonar
        }

    fun use(type: AttackType): AttackCharges =
        when (type) {
            AttackType.TORPEDO -> this
            AttackType.CROSS_FIRE -> copy(crossFire = crossFire - 1)
            AttackType.CLUSTER_BOMB -> copy(clusterBomb = clusterBomb - 1)
            AttackType.LINE_STRIKE -> copy(lineStrike = lineStrike - 1)
            AttackType.SONAR -> copy(sonar = sonar - 1)
        }

    fun canUse(type: AttackType): Boolean =
        type == AttackType.TORPEDO || chargeFor(type) > 0

    fun rechargeOnSink(): AttackCharges =
        copy(
            crossFire = minOf(crossFire + 1, AttackType.CROSS_FIRE.maxCharges),
            clusterBomb = minOf(clusterBomb + 1, AttackType.CLUSTER_BOMB.maxCharges),
            sonar = minOf(sonar + 1, AttackType.SONAR.maxCharges)
        )
}
